module.exports = __webpack_public_path__ + "static/media/portuguese.2f523d06.svg";